<template>
  <div class="container schedule-print">
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-center"
      >
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
      <table class="table table-sm bg-white">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 pb-0 text-center"
            >
              <img
                v-if="rest_home_logo_url"
                class="rest_home_logo_url"
                :src="rest_home_logo_url"
              />
              <h6 class="text-uppercase" v-if="!rest_home_logo_url">
                {{ rest_home_name }}
              </h6>
            </div>
            <div
              class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pb-0 pt-0 d-flex align-items-center"
            >
              <img
                v-if="schedule.resident_photo_url"
                class="resident_photo_url"
                :src="schedule.resident_photo_url"
              />
              <img
                v-if="!schedule.resident_photo_url"
                class="resident_photo_url"
                :src="require('../../../assets/user.png')"
              />
              <ResidentDataPrintDefault :resident_id="schedule.resident_id" />
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pb-0 check-text-right"
            >
              <div>
                <img class="logo" :src="logo" width="180" />
                <h6
                  v-if="schedule.finish_date"
                  class="pr-5 pt-5 worksansr upper-text check-text-right"
                >
                  Data:
                  {{ formatDate(schedule.finish_date, false) }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <hr class="m-0" />
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0">
          <div class="row">
            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pt-1 pb-1">
              <h6 class="mb-0 upper-text text-thirteen">
                Medicamentos - Prescrição Médica - Validade
                <span class="color-blue">{{
                  formatDate(schedule.start_date, false)
                }}</span>
                até
                <span class="color-blue upper-text text-thirteen">{{
                  formatDate(schedule.end_date, false)
                }}</span>
              </h6>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 pt-1 pb-1">
              <h6 class="mb-0 upper-text text-thirteen check-text-center">
                Aprazamento
              </h6>
            </div>
          </div>
        </div>
        <hr class="m-0" />
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
          style="page-break-inside: avoid !important"
          v-for="(item, key_medicine) in schedule.prescription_medicines"
          :key="key_medicine"
        >
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-1 pb-1">
              <div class="name">
                <h6 class="mb-0 text-fourteen check-text-center">
                  <strong>{{ item.medicine_name }}</strong>
                </h6>
                <h6 class="legends worksansr mb-0 check-text-center">
                  {{ item.medicine_active_ingredient }}
                </h6>
                <h6
                  v-if="
                    item.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'
                  "
                  class="color-yellow text-thirteen mb-0 check-text-center"
                >
                  CONTROLE ESPECIAL
                </h6>
                <h6
                  v-if="item.medicine_list"
                  class="legends worksansr mb-0 check-text-center"
                >
                  LISTA:
                  {{ item.medicine_list }}
                </h6>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-1 pb-1">
              <!-- ABRE - DIAS DA SEMANA -->
              <h6 class="legends worksansr mb-1 check-text-center">
                <span v-if="item.frequency == 'SEMANAL'">
                  {{ item.dom && "DOM" }} - {{ item.seg && "SEG" }} -
                  {{ item.ter && "TER" }} - {{ item.qua && "QUA" }} -
                  {{ item.qui && "QUI" }} - {{ item.sex && "SEX" }} -
                  {{ item.sab && "SAB" }} - /
                </span>
                <span
                  v-if="
                    item.medicine_amount_of_times_type == 'DAY' ||
                    item.frequency == 'EVENTUAL'
                  "
                >
                  {{
                    item.drops_quantity
                      ? `${item.drops_quantity} GOTA(S)`
                      : item.ui_quantity
                      ? `${item.ui_quantity} UI`
                      : item.quantity
                  }}
                  {{
                    item.drops_quantity
                      ? ""
                      : item.ui_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation}`
                  }}
                  /</span
                >
                <span
                  v-if="
                    item.frequency != 'EVENTUAL' &&
                    item.medicine_amount_of_times_name
                  "
                >
                  {{ item.medicine_amount_of_times_name }}
                </span>
              </h6>
              <h6 class="legends worksansr mb-1 check-text-center">
                <span v-if="item.dawn && item.dawn_quantity">
                  {{
                    item.drops_dawn_quantity
                      ? `${item.drops_dawn_quantity} GOTA(S)`
                      : item.ui_dawn_quantity
                      ? `${item.ui_dawn_quantity} UI`
                      : item.dawn_quantity
                  }}
                  {{
                    item.drops_dawn_quantity
                      ? ""
                      : item.ui_dawn_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - MADRUGADA /
                </span>
                <span v-if="item.morning && item.morning_quantity">
                  {{
                    item.drops_morning_quantity
                      ? `${item.drops_morning_quantity} GOTA(S)`
                      : item.ui_morning_quantity
                      ? `${item.ui_morning_quantity} UI`
                      : item.morning_quantity
                  }}
                  {{
                    item.drops_morning_quantity
                      ? ""
                      : item.ui_morning_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - MANHÃ /
                </span>
                <span v-if="item.afternoon && item.afternoon_quantity">
                  {{
                    item.drops_afternoon_quantity
                      ? `${item.drops_afternoon_quantity} GOTA(S)`
                      : item.ui_afternoon_quantity
                      ? `${item.ui_afternoon_quantity} UI`
                      : item.afternoon_quantity
                  }}
                  {{
                    item.drops_afternoon_quantity
                      ? ""
                      : item.ui_afternoon_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - TARDE /
                </span>
                <span v-if="item.night && item.night_quantity">
                  {{
                    item.drops_night_quantity
                      ? `${item.drops_night_quantity} GOTA(S)`
                      : item.ui_night_quantity
                      ? `${item.ui_night_quantity} UI`
                      : item.night_quantity
                  }}
                  {{
                    item.drops_night_quantity
                      ? ""
                      : item.ui_night_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - NOITE /
                </span>
                <span v-if="item.shift_5 && item.shift_5_quantity">
                  {{
                    item.drops_shift_5_quantity
                      ? `${item.drops_shift_5_quantity} GOTA(S)`
                      : item.ui_shift_5_quantity
                      ? `${item.ui_shift_5_quantity} UI`
                      : item.shift_5_quantity
                  }}
                  {{
                    item.drops_shift_5_quantity
                      ? ""
                      : item.ui_shift_5_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - 5º /
                </span>
                <span v-if="item.shift_6 && item.shift_6_quantity">
                  {{
                    item.drops_shift_6_quantity
                      ? `${item.drops_shift_6_quantity} GOTA(S)`
                      : item.ui_shift_6_quantity
                      ? `${item.ui_shift_6_quantity} UI`
                      : item.shift_6_quantity
                  }}
                  {{
                    item.drops_shift_6_quantity
                      ? ""
                      : item.ui_shift_6_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - 6º /
                </span>
                <span v-if="item.shift_7 && item.shift_7_quantity">
                  {{
                    item.drops_shift_7_quantity
                      ? `${item.drops_shift_7_quantity} GOTA(S)`
                      : item.ui_shift_7_quantity
                      ? `${item.ui_shift_7_quantity} UI`
                      : item.shift_7_quantity
                  }}
                  {{
                    item.drops_shift_7_quantity
                      ? ""
                      : item.ui_shift_7_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - 7º /
                </span>
                <span v-if="item.shift_8 && item.shift_8_quantity">
                  {{
                    item.drops_shift_8_quantity
                      ? `${item.drops_shift_8_quantity} GOTA(S)`
                      : item.ui_shift_8_quantity
                      ? `${item.ui_shift_8_quantity} UI`
                      : item.shift_8_quantity
                  }}
                  {{
                    item.drops_shift_8_quantity
                      ? ""
                      : item.ui_shift_8_quantity
                      ? ""
                      : `${item.unit_of_measurement_abbreviation} (S)`
                  }}
                  - 8º /
                </span>
                <span v-if="item.frequency != 'EVENTUAL'">
                  Uso:
                  {{ handleDuration(item.duration) }}
                  /
                </span>
                <span v-if="item.frequency == 'EVENTUAL'">Eventual /</span>
                <span>Via: {{ item.route_of_administration_name }}</span>
              </h6>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 pt-1 pb-1">
              Horário(s)
              <p
                class="m-0 worksansr"
                v-for="(time, key_time) in item.prescription_medicine_time"
                :key="`${time.id}-${key_time}`"
              >
                {{
                  time.time
                    ? String(time.time).substring(
                        0,
                        String(time.time).length - 3
                      )
                    : "Não informado"
                }}
              </p>
            </div>
          </div>
          <hr class="mt-0 mb-0 border-black" />
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          style="page-break-inside: avoid !important"
        >
          <div class="row" style="page-break-inside: avoid !important">
            <div
              v-if="schedule.finish_user && schedule.status != 'INATIVO'"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <img
                :class="[
                  'mr-2',
                  schedule.finish_user.photo_url
                    ? 'user-photo-url'
                    : 'no-user-photo-url',
                ]"
                :src="
                  schedule.finish_user.photo_url
                    ? schedule.finish_user.photo_url
                    : require('../../../assets/user.png')
                "
              />
              <h6 class="mb-0 worksansr text-fourteen">
                Prescrição finalizada por
                {{
                  professionalClassCouncilValue({
                    id: schedule.finish_user.professional_class_council_id,
                    name: schedule.finish_user.name,
                    value:
                      schedule.finish_user.professional_class_council_value,
                    cpf: schedule.finish_user.cpf,
                    office: schedule.finish_user.office,
                  })
                }}
                - {{ formatDate(schedule.updated_at) }},
                <strong
                  v-if="schedule.status == 'FINALIZADO'"
                  class="worksansr"
                >
                  {{
                    schedule.certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                  <span v-if="schedule.certificate" class="ml-1 v-clean">{{
                    schedule.certificate
                  }}</span>
                </strong>
              </h6>
            </div>
            <div
              v-if="
                schedule.user_finish_prescription_medicine_time &&
                schedule.status != 'INATIVO'
              "
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <img
                :class="[
                  'mr-2',
                  schedule.user_finish_prescription_medicine_time.photo_url
                    ? 'user-photo-url'
                    : 'no-user-photo-url',
                ]"
                :src="
                  schedule.user_finish_prescription_medicine_time.photo_url
                    ? schedule.user_finish_prescription_medicine_time.photo_url
                    : require('../../../assets/user.png')
                "
              />
              <h6 class="mb-0 worksansr text-fourteen">
                Aprazamento finalizado por
                {{
                  professionalClassCouncilValue({
                    id: schedule.user_finish_prescription_medicine_time
                      .professional_class_council_id,
                    name: schedule.user_finish_prescription_medicine_time.name,
                    value:
                      schedule.user_finish_prescription_medicine_time
                        .professional_class_council_value,
                    cpf: schedule.user_finish_prescription_medicine_time.cpf,
                    office:
                      schedule.user_finish_prescription_medicine_time.office,
                  })
                }},
                <strong
                  v-if="
                    schedule.status_prescription_medicine_time == 'FINALIZADO'
                  "
                  class="mb-0 worksansr text-fourteen"
                >
                  {{
                    schedule.prescription_medicine_time_certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                  <span
                    v-if="schedule.prescription_medicine_time_certificate"
                    class="ml-1 v-clean"
                    >{{ schedule.prescription_medicine_time_certificate }}</span
                  >.
                </strong>
              </h6>
            </div>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center mt-5"
            v-if="userData().show_user_on_print == 1"
          >
            <hr class="border-black" />
            Gerado por
            {{
              professionalClassCouncilValue({
                id: user.professional_class_council_id,
                name: user.name,
                profile: user.profile_name,
                cpf: user.cpf,
                office: user.office,
                value: user.professional_class_council_value,
              })
            }}
            <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
          </div>
        </div>
      </table>
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-center"
      >
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintDefault from "../../../components/resident/ResidentDataPrintDefault";

import { userData } from "../../../lib/functions";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import api from "../../../services/api";

import routes from "../../../routes";

import moment from "moment";

import { showUserOnPrint } from "../../../lib/show-user-on-print";

export default {
  name: "Print",
  components: { ResidentDataPrintDefault },
  data() {
    return {
      id: "",
      user: {},
      schedule: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    userData,
    formatDate,
    professionalClassCouncilValue,
    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
    async retrieve() {
      let { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let { show_user_on_print } = userData();
      if (show_user_on_print != 1) {
        await showUserOnPrint({
          about: "Aprazamento prescrição de medicamento",
        });
      }

      let { id } = routes.history.current.params;

      this.id = id;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = {
          id,
        };

        const response = await api.get("/rest-home/schedule/print", {
          params,
        });

        const { error, errors, schedule } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.schedule = schedule;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
    },
  },
};
</script>

<style>
table.report-container {
  width: 100%;
  /* page-break-after: always; */
}
thead.report-header {
  display: table-header-group;
}
tfoot.report-footer {
  display: table-footer-group;
}
.schedule-print .logo {
  height: 50px;
  object-fit: contain;
}
.schedule-print .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.schedule-print .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}
.schedule-print .medicine .capsule {
  width: 20px;
}

.schedule-print .medicine .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.schedule-print .medicine .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-end;
}
.schedule-print .medicine .frequency strong {
  font-size: 18px;
}
.schedule-print li {
  list-style-type: none;
}
@media print {
  .schedule-print button {
    display: none;
  }
  .schedule-print li {
    list-style-type: none;
  }
}
</style>
